import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {GroupMember} from '../../../graphql/groups.datatypes';

interface GroupMembersData {
    groupMembersInMyGroup: void
    myTravellers: void
    myGroupMembers: void,
    groupMembers: {
        data: GroupMember[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const gqlGroupMember = `
    id
    cancelled
    authorised
    first_name
    last_name
    group_role
    tour_role

    roomMember {
        id
        billing_party_id
        start_date
        end_date
        cost
        outstandingBalance

        billingParty {
            id

            payingMembers {
                id
                primary_paying_member
                first_name
                last_name
            }
        }
    }

    group {
        id
        name
        end_date
    }
`;

export const GET_GROUP_MEMBERS_QUERY = gql`
  query getGroupMembers($count: Int!, $page: Int!, $where: WhereConditions, $hasRoomMember: QueryGroupMembersHasRoomMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    groupMembers(first: $count, page: $page, where: $where, hasRoomMember: $hasRoomMember, orderBy: $orderBy){
      data {
        ${gqlGroupMember}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getGroupMembers = (count: number, page: number, where?: any, orderBy?: any, hasRoomMember?: any) => useQuery<GroupMembersData>(
    GET_GROUP_MEMBERS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
            hasRoomMember,
        },

    }
);

export default getGroupMembers;
